// import event Bus
import maEventBus from '@/components/eventbus/index.js'

export default {
  name: 'buttonForm',
  data: function () {
    return {
      btnIsChecked: false,
      showDeleteBtn: false
    }
  },

  props: {
    handleButtonClick: Function,
    iconName: String,
    buttonTitle: String,
    valueInput: String,
    type: String,
    buttonClass: String,
    inputChecked: Boolean,
    imgSrc: String,
    imgName: String,
    buttonSubtitle: String,
    idButton: Number,
    quantitySelected: Number
  },

  methods: {
    handleMoreOptions() {
      this.showDeleteBtn = !this.showDeleteBtn
    },

    getImgPath(imgName) {
      let S3_URL
      S3_URL = process.env.S3_URL
      return S3_URL + imgName
    },

    handleOnClickIncremental() {
      const quantity = this.btnIsChecked ? 0 : 1
      this.$emit('button:quantityChanged', quantity)
      this.btnIsChecked = !this.btnIsChecked
    },

    handleOnDecrementValue() {
      let quantity = this.quantitySelected
      if (quantity <= 1) {
        this.btnIsChecked = false
        quantity = 0
      } else {
        quantity--
      }
      this.$emit('button:quantityChanged', quantity)
    },

    handleOnIncrementValue() {
      this.$emit('button:quantityChanged', this.quantitySelected + 1)
    }
  },

  mounted() {
    if (this.quantitySelected > 0 || this.inputChecked) this.btnIsChecked = true
    maEventBus.$on('btnDelete:clicked', () => {
      this.showDeleteBtn = false
    })
  }
}
